import React, { Component } from "react";
import FlatButton from "material-ui/FlatButton";
import Delete from "material-ui/svg-icons/action/delete";
import IconButton from "material-ui/IconButton";
import ApiKeyIcon from "material-ui/svg-icons/communication/vpn-key";
import ShowKeyIcon from "material-ui/svg-icons/action/visibility";
import RevokeKeyIcon from "material-ui/svg-icons/content/block";
import { FormattedMessage, injectIntl } from "react-intl";
import images from "../../config/images";
import Clipboard from "react-clipboard.js";
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableRowColumn,
} from "material-ui";
import { tableStyles } from "../../layouts/tableStyle";
import Button from "../EmailAddressBook/Button";

const tableHeaders = [
  {
    label: "inviteModal.recording.name",
    colSpan: 3,
  },
  {
    label: "seminarActions.tableHeading.email",
    colSpan: 3,
  },
  {
    label: "contacts.role",
    colSpan: 2,
  },
  {
    label: "emailAddressBook.edit",
    colSpan: 1,
  },
  {
    label: "roomRecordings.delete",
    colSpan: 1,
  },
];

function Header(props) {
  return (
    <div className="mt2">
      <div className="flex justify-between mt2 items-center">
        <div className="flex user-list-header">
          <Button 
            label={<FormattedMessage id="user.add" />} 
            help={false} 
            minWidth="unset" 
            maxWidth="200px"
            className="add-user-btn"
            handleButtonClick={(e) => props.handleListClick(e, "addUser")}
          />
          <div className="flex ml3 user-list-info" style={{ border: '1.5px solid #b6b6b6', height: '42px', marginTop: '4px' }}>
            <span style={{ backgroundColor: '#6b7c93', color: '#fff' }} className="ttu pl3 pr3 flex items-center">
              <FormattedMessage id="CreateDomainLabel.totalUsers" />
            </span>
            <span className="info" style={{ minWidth: '80px', margin: 'auto' }}>{ props.users.length }</span>
            <span style={{ backgroundColor: '#6b7c93', color: '#fff' }} className="ttu pl3 pr3 flex items-center">
              <FormattedMessage id="CreateDomainLabel.maxAccountNoUser" />
            </span>
            <span className="info" style={{ minWidth: '80px', margin: 'auto' }}>{ props.max_account_number }</span>
          </div>
        </div>
      </div>
    </div>
  );
}

class UserTable extends Component {
  componentDidMount() {
    if (this.props.showAdminTokenActions) {
      if (!tableHeaders.find((h) => h.id === "actions"))
        tableHeaders.push({
          label: <FormattedMessage id="CreateDomainLabel.action" />,
          colSpan: 2,
          id: "actions",
        });
    }
  }

  handleDelete = (e, user, message) => {
    if (window.confirm(message)) {
      this.props.handleDeleteTouch(
        e,
        <div>
          {user.name}
          <FormattedMessage id="seminarActions.singleRemoved" />
        </div>,
        user.id,
        user.fvdomain_id
      );
    }
  };

  render() {
    const { intl } = this.props;

    return (
      <div style={{ textAlign: "center" }}>
        <Header
          users={this.props.users}
          max_account_number={this.props.max_account_number}
          handleListClick={(e) => this.props.hadleListClick(e, "addUser")}
        />

        <div className="table-wrapper mt3">
          <Table
            selectable={false}
            fixedHeader={true}
            height="70vh"
            style={tableStyles.table}
          >
            <TableHeader
              displaySelectAll={false}
              enableSelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow style={tableStyles.tableHeaderRow}>
                {tableHeaders.map((header) => {
                  return (
                    <TableRowColumn
                      colSpan={header.colSpan}
                      style={{ ...tableStyles.tableData, color: "#fff" }}
                    >
                      <FormattedMessage id={header.label} />
                    </TableRowColumn>
                  );
                })}
              </TableRow>
            </TableHeader>
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              {(this.props.isFetchingList ||
                (!this.props.isFetchingList &&
                  this.props.users.length === 0)) && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={tableStyles.tableBodyRow}
                >
                  <TableRowColumn
                    colSpan={10 + (this.props.showAdminTokenActions ? 2 : 0)}
                    style={tableStyles.tableData}
                  >
                    <FormattedMessage
                      id={
                        this.props.isFetchingList
                          ? "login.fetching"
                          : "user.notFoundUser"
                      }
                    />
                  </TableRowColumn>
                </TableRow>
              )}

              {this.props.users.map((user, index) => {
                return (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={tableStyles.tableBodyRow}
                  >
                    <TableRowColumn colSpan={3} style={tableStyles.tableData}>
                      {user.name}
                    </TableRowColumn>
                    <TableRowColumn colSpan={3} style={tableStyles.tableData}>
                      {user.email}
                    </TableRowColumn>
                    <TableRowColumn colSpan={2} style={tableStyles.tableData}>
                      <FormattedMessage
                        id={
                          user.fvlite_role === "admin"
                            ? "user.admin"
                            : "user.guest"
                        }
                      />
                    </TableRowColumn>
                    <TableRowColumn colSpan={1} style={tableStyles.tableData}>
                      <img 
                        style={{ height: "23px", cursor: "pointer" }} 
                        onClick={(e) =>
                          this.props.editDetails(
                            user.name,
                            user.email,
                            user.fvlite_role,
                            user.fvdomain_id,
                            user.id
                          )
                        } 
                        src={images.editIcon} 
                      />
                    </TableRowColumn>
                    <TableRowColumn colSpan={1} style={tableStyles.tableData}>
                      <Delete 
                        color="#6B7c93" 
                        onClick={(e) =>
                          this.handleDelete(
                            e,
                            user,
                            intl.formatMessage({ id: "user.deleteConfirm" })
                          )
                        } 
                        style={{ height: "23px", cursor: "pointer" }} 
                      />
                    </TableRowColumn>
                    {this.props.showAdminTokenActions && (
                      <TableRowColumn colSpan={2} style={tableStyles.tableData}>
                        {user.api_token && <Clipboard
                          data-clipboard-text={user.api_token}
                          onSuccess={true}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0px",
                          }}
                        >
                          <IconButton
                            iconStyle={{ fill: "#afb8c5" }}
                            touchRippleColor="green"
                            tooltip={
                              <FormattedMessage id="contacts.copyApiToken" />
                            }
                            tooltipStyles={{ transform: 'translate(0px, -3px)' }}
                          >
                            <ShowKeyIcon />
                          </IconButton>
                        </Clipboard>}
                        {user.api_token && <IconButton
                          onTouchTap={(e) =>
                            this.props.handleRevokeApiTokenTouch(
                              user.id,
                              user.fvdomain_id
                            )
                          }
                          iconStyle={{ fill: "#afb8c5" }}
                          tooltip={
                            <FormattedMessage id="contacts.revokeToken" />
                          }
                          tooltipStyles={{ transform: 'translate(0px, -3px)' }}
                        >
                          <RevokeKeyIcon />
                        </IconButton>}
                        {!user.api_token && <IconButton
                          onTouchTap={(e) =>
                            this.props.handleGenApiTokenTouch(
                              user.id,
                              user.fvdomain_id
                            )
                          }
                          iconStyle={{ fill: "#afb8c5" }}
                          tooltip={<FormattedMessage id="contacts.genToken" />}
                          tooltipStyles={{ transform: 'translate(0px, -3px)' }}
                        >
                          <ApiKeyIcon />
                        </IconButton>}
                      </TableRowColumn>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export default injectIntl(UserTable);



// WEBPACK FOOTER //
// src/components/UserTable/Table.js